import actionTypes from '../constants/action-types';

const designAutomation = (state = {}, action) => {
  if (action.type !== actionTypes.SET_DESIGN_AUTOMATION_CONFIG) {
    return state;
  }

  return action.payload.config;
};

export default designAutomation;
